var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('GithubRepo',{on:{"reposelected":_vm.onRepoSelected}}),_c('GithubArquivos',{attrs:{"repo":_vm.repo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }